import { useProxyStore, type MatchReplaceRule } from '../store/proxy-store';

export function mapMatchReplaceRulesForIpc(rules: MatchReplaceRule[]) {
  return rules.map((rule) => ({
    id: rule.id,
    name: rule.name,
    enabled: rule.enabled,
    matchType: rule.matchType,
    matchLocation: rule.matchLocation,
    matchPattern: rule.matchPattern,
    isRegex: rule.isRegex,
    caseSensitive: rule.caseSensitive,
    headerName: rule.headerName,
    replaceWith: rule.replaceWith,
    replaceType: rule.replaceType,
    applyTo: rule.applyTo,
    conditions: rule.conditions,
  }));
}

export async function syncMatchReplaceRulesToElectronProxy(): Promise<{
  success: boolean;
  error?: string;
}> {
  if (typeof window === 'undefined' || !window.electronAPI) {
    return { success: false, error: 'Electron API is not available' };
  }

  const { settings } = useProxyStore.getState();
  const mappedRules = mapMatchReplaceRulesForIpc(
    settings.matchReplaceRules ?? [],
  );

  const result = await window.electronAPI.proxy.updateConfig({
    matchReplaceRules: {
      enabled: true,
      rules: mappedRules,
    },
  });

  if (!result.success) {
    return {
      success: false,
      error: result.error ?? 'Failed to sync match/replace rules to proxy',
    };
  }

  return { success: true };
}
